export interface UpdateCampaignStatusPayload {
  id: string;
  status: CampaignStatus;
}

export enum CampaignStatus {
  DRAFT = "draft",
  PUBLISHED = "published",
  CLOSED = "ended",
  IN_REVIEW = "in_review",
  REJECTED="rejected",
}
